export const getUnmaskedValue = (value: string) =>
  String(value).replace(/\D/g, '');

export const formatCNPJ = (input: string) => {
  const value = String(input) // Transforma em String
    .replace(/\D/g, '') // Retira o que não é número
    .slice(0, 14)
    .replace(/(\d{2})(\d{1,3})/, '$1.$2')
    .replace(/(\d{3})(\d{1,3})/, '$1.$2')
    .replace(/(\d{3})(\d{1,4})/, '$1/$2')
    .replace(/(\d{4})(\d{1,2})/, '$1-$2');

  return value;
};

export const formatCPF = (input: string) => {
  const value = String(input) // Transforma em String
    .replace(/\D/g, '') // Retira o que não é número
    .slice(0, 11) // Limita o tamanho
    .replace(/(\d{3})(\d{1,3})/, '$1.$2') // Coloca o primeiro ponto
    .replace(/(\d{3})(\d{1,3})/, '$1.$2') // Coloca o segundo ponto
    .replace(/(\d{3}\.{1}\d{3}\.{1}\d{3})(\d{1,2})/, '$1-$2'); // Coloca o traço
  return value;
};

export const formatCPFCNPJ = (input: string) => {
  let value = String(input).replace(/\D/g, '').slice(0, 14);
  if (value.length > 11) return formatCNPJ(value);
  return formatCPF(value);
};

export const formatCEP = (input: string) => {
  const value = String(input) // Transforma em String
    .replace(/\D/g, '') // Retira o que não é número
    .slice(0, 8) // Limita o tamanho
    .replace(/(\d{5})(\d{1,2})/, '$1-$2'); // Coloca o primeiro ponto
  return value;
};

export const formatTelefone = (input: string) => {
  const value = String(input) // Transforma em String
    .replace(/\D/g, '') // Retira o que não é número
    .slice(0, 11) // Limita o tamanho
    .replace(/(\d{1,2})/, '($1') // Coloca o primeiro parênteses
    .replace(/(\({1}\d{2})(.+)/, '$1) $2') // Coloca o segundo parênteses
    .replace(/(\(\d\d\)\s)(\d{4})(\d{1,4})/, '$1$2-$3') // Coloca o - no formato 8 dígitos
    .replace(/(\(\d\d\)\s)(\d{4})(-)(\d{1})(\d{4})/, '$1$2$4-$5'); // Coloca o - no formato 9 dígitos
  return value;
};

export const formatData = (input: string) => {
  const value = String(input)
    .replace(/\D/g, '') // Retira o que não é número
    .slice(0, 8) // Limita o tamanho
    .replace(/(\d{2})(\d{1,})/, '$1/$2') // Coloca a primeira barra
    .replace(/(\d{2}\/\d{2})(\d{1,2})/, '$1/$2') // Coloca a segunda barra
    .replace(/(\d{2}\/\d{2}\/)(\d{1,4}) /, '$1/$2'); // Coloca a terceira barra
  return value;
};

export const formatHora = (input: string) => {
  const value = String(input)
    .replace(/\D/g, '') // Retira o que não é número
    .slice(0, 4) // Limita o tamanho
    .replace(/(\d{2})(\d{1,2})/, '$1:$2'); // Coloca os dois pontos
  return value;
};

export const getStringWithoutSpecialChar = (input: string) => {
  const value = String(input)
    .replace(/ã/g, 'a')
    .replace(/Ã/g, 'A')
    .replace(/á/g, 'a')
    .replace(/Á/g, 'A')
    .replace(/à/g, 'a')
    .replace(/À/g, 'A')
    .replace(/â/g, 'a')
    .replace(/Â/g, 'A')
    .replace(/é/g, 'e')
    .replace(/ê/g, 'e')
    .replace(/Ê/g, 'e')
    .replace(/É/g, 'E')
    .replace(/è/g, 'e')
    .replace(/È/g, 'E')
    .replace(/ì/g, 'i')
    .replace(/Ì/g, 'I')
    .replace(/í/g, 'i')
    .replace(/Í/g, 'I')
    .replace(/ó/g, 'o')
    .replace(/Ó/g, 'o')
    .replace(/ò/g, 'o')
    .replace(/Ò/g, 'o')
    .replace(/ô/g, 'o')
    .replace(/Ô/g, 'O')
    .replace(/õ/g, 'o')
    .replace(/Õ/g, 'O')
    .replace(/ç/g, 'c')
    .replace(/Ç/g, 'C');
  return value;
};

export const formatConta = (value: string, max = 15) => {
  return String(value)
    .replace(/\D/g, '')
    .slice(0, max)

    .replace(/^(\d+)(\d{1})$/i, '$1-$2');
};

export const formatNumber = (value: string) => {
  return value.replace(/\D/g, '')
} 
